module.exports = __webpack_public_path__ + "assets/img/qrcode-cdf2c4f7.png";